// @flow
import * as React from 'react';

const P = ({ children }: { children: React.Node }) => (
  <p className="my-6 text-gray-darker leading-normal">{children}</p>
);

export default P;
